
import React from 'react';
import { Business } from '@/types/business';

interface BusinessFormHeaderProps {
  business: Business | null;
}

const BusinessFormHeader: React.FC<BusinessFormHeaderProps> = ({ business }) => {
  return (
    <div className="mb-4">
      <h2 className="text-xl font-bold">
        {business ? 'Edit Business' : 'Add New Business'}
      </h2>
      <p className="text-sm text-gray-500">
        {business 
          ? 'Update the details of your existing business' 
          : 'Fill in the details to create a new business'}
      </p>
    </div>
  );
};

export default BusinessFormHeader;
